/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // NO-OP
    },
    registered() {
      // NO-OP
    },
    cached() {
      // NO-OP
    },
    updatefound() {
      // NO-OP
    },
    updated() {
      // NO-OP
    },
    offline() {
      // NO-OP
    },
    error(error) {
      // NO-OP
    }
  })
}
